import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentPipe } from '@ap/content';
import { ApModalComponent } from '@ap/modal';

import { SendableOrdersModalComponent } from './sendable-orders-modal.component';

/**
 * @ngdoc module
 * @name SendableOrdersModalModule
 **/
@NgModule({
    declarations: [SendableOrdersModalComponent],
    imports: [ApButtonComponent, CommonModule, ApContentPipe, ApModalComponent],
    exports: [SendableOrdersModalComponent]
})
export class SendableOrdersModalModule {}
